export type StaffRole = 'staff' | 'manager' | 'admin'

export interface StaffPermissions {
  can_view_shift_financials: boolean
  can_view_stock: boolean
  can_see_stock_levels: boolean
  can_update_stock: boolean
  can_apply_discount: boolean
  can_void_item: boolean
  can_process_refund: boolean
  can_manage_staff: boolean
}

const ALL_FALSE: StaffPermissions = {
  can_view_shift_financials: false,
  can_view_stock: false,
  can_see_stock_levels: false,
  can_update_stock: false,
  can_apply_discount: false,
  can_void_item: false,
  can_process_refund: false,
  can_manage_staff: false,
}

export function DEFAULT_PERMISSIONS_BY_ROLE(role: StaffRole): StaffPermissions {
  if (role === 'admin') {
    return { can_view_shift_financials: true, can_view_stock: true, can_see_stock_levels: true, can_update_stock: true, can_apply_discount: true, can_void_item: true, can_process_refund: true, can_manage_staff: true }
  }
  if (role === 'manager') {
    return { ...ALL_FALSE, can_view_shift_financials: true, can_view_stock: true, can_see_stock_levels: true, can_update_stock: true, can_apply_discount: true, can_void_item: true }
  }
  return { ...ALL_FALSE }
}
